import { DEFAULT_MOBILE_HEIGHT, DESKTOP_FOOTER_HEIGHT, MOBILE_FOOTER_HEIGHT } from '@anm/constants/videoLandings';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { device } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';
var containerDirectionVariants = {
  row: css(["@media ", "{display:flex;align-items:", ";justify-content:center;}"], device.laptop, function (_ref) {
    var topAligned = _ref.topAligned;
    return topAligned ? 'flex-start' : 'center';
  }),
  column: css([""])
};
var templateVariants = {
  basic: css(["padding:48px 19px;@media ", "{padding:48px 60px;}@media ", "{margin:0 auto;padding:48px 60px;", "}"], device.laptop, device.laptop, function (_ref2) {
    var layoutDirection = _ref2.layoutDirection;
    return layoutDirection === 'column' ? css(["text-align:center;"]) : css(["& > div{&:not(:first-child){@media ", "{margin:0;}}&:nth-child(3){@media ", "{display:none;}}}"], device.laptop, device.laptop);
  }),
  t1: css(["padding:48px 19px;@media ", "{padding:48px 60px;}"], device.laptop),
  t2: css(["padding:48px 19px;@media ", "{padding:48px 60px;}"], device.laptop),
  t3: css(["padding:48px 19px;@media ", "{padding:48px 60px;& > div:not(:last-child){margin:0;}}"], device.laptop),
  t4: css(["padding:48px 19px;@media ", "{padding:48px 60px;}"], device.laptop),
  t5: css(["padding:48px 19px 92px;@media ", "{padding:48px 19px 80px;}"], device.laptop)
};
export var FOOTER_HEIGHT = isMobileOrIPad() ? DESKTOP_FOOTER_HEIGHT : MOBILE_FOOTER_HEIGHT;

var getFooterHeight = function getFooterHeight(hasFooter, viewType) {
  var isMobileView = viewType === 'mobile';
  var footerHeight = isMobileView ? DESKTOP_FOOTER_HEIGHT : hasFooter ? FOOTER_HEIGHT : 0;
  return footerHeight;
};

var Container = styled.div.withConfig({
  componentId: "o7osws-0"
})(["margin:0 auto;", " min-height:", ";", ";pre{white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;background-color:#f8f8f8;border:1px solid #dfdfdf;margin-top:1.5em;margin-bottom:1.5em;padding:0.125rem 0.3125rem 0.0625rem;}ul{font-family:inherit;font-size:1rem;line-height:1.6;list-style-position:outside;margin-bottom:1.25rem;margin-left:1.1rem;li{margin:0;padding:0;}}"], function (_ref3) {
  var variant = _ref3.variant;
  return templateVariants[variant];
}, function (_ref4) {
  var hasFooter = _ref4.hasFooter,
      minHeight = _ref4.minHeight,
      viewType = _ref4.viewType,
      _ref4$isCustomization = _ref4.isCustomization,
      isCustomization = _ref4$isCustomization === void 0 ? false : _ref4$isCustomization;
  return minHeight ? "".concat(minHeight, "px") : !isCustomization ? "calc(100vh - ".concat(getFooterHeight(hasFooter), "px)") : "calc(".concat(DEFAULT_MOBILE_HEIGHT, "px - ").concat(getFooterHeight(hasFooter, viewType), "px)");
}, function (_ref5) {
  var layoutDirection = _ref5.layoutDirection;
  return containerDirectionVariants[layoutDirection || 'column'];
});
export default Container;